module.exports = __webpack_public_path__ + "static/media/d3js-logo.9f064f46.png";